export default {
    groups: [
        {
            id: 1,
            label: 'Административно-территориальный формат',
            collapsed: false,
        },
        {
            id: 2,
            label: 'Муниципальный формат',
            collapsed: false,
        },
    ],
    components: [
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Почтовый индекс',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'ac_postalcode',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Код субъекта РФ, который является учредителем ЮЛ',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'ac_regioncode',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Тип элемента регион (республика, край и т.п.)',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'ac_region_type',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Наименование (элемент регион)',
            groupId: 1,
            size: [1, 4],
            fieldNameText: 'ac_region_name',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Тип элемента район (район, улус и т.п.)',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'ac_district_type',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Наименование (элемент район)',
            groupId: 1,
            size: [1, 4],
            fieldNameText: 'ac_district_name',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Тип элемента город (город, волость и т.п.)',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'ac_city_type',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Наименование (элемент город)',
            groupId: 1,
            size: [1, 4],
            fieldNameText: 'ac_city_name',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Тип элемента населённый пункт (посёлок, село и т.п.)',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'ac_place_type',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Наименование (элемент населённый пункт)',
            groupId: 1,
            size: [1, 4],
            fieldNameText: 'ac_place_name',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Тип адресного объекта улица (улица, проспект, переулок и т.п.)',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'ac_street_type',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Наименование (элемент улица)',
            groupId: 1,
            size: [1, 4],
            fieldNameText: 'ac_street_name',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Дом (владение и т.п.)',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'ac_house',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Корпус (строение и т.п.)',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'ac_building',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Квартира (офис и т.п.)',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'ac_flat',
        },

        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Почтовый индекс',
            groupId: 2,
            size: [1, 2],
            fieldNameText: 'acm_postalcode',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Наименование субъекта Российской Федерации',
            groupId: 2,
            size: [1, 4],
            fieldNameText: 'acm_region_name',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: '',
            groupId: 2,
            size: [1, 1],
            fieldNameText: 'acm_distr_city_type',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Муниципальный район/ городской округ/ внутригородская территория города федерального значения',
            groupId: 2,
            size: [1, 5],
            fieldNameText: 'acm_distr_city_name',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: '',
            groupId: 2,
            size: [1, 1],
            fieldNameText: 'acm_place_type',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Городское поселение / сельское поселение / внутригородской район городского округа',
            groupId: 2,
            size: [1, 5],
            fieldNameText: 'acm_place_name',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: '',
            groupId: 2,
            size: [1, 1],
            fieldNameText: 'acm_locality_type',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Населенный пункт (город, деревня, село и прочее)',
            groupId: 2,
            size: [1, 5],
            fieldNameText: 'acm_locality_name',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: '',
            groupId: 2,
            size: [1, 1],
            fieldNameText: 'acm_plan_type',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Элемент планировочной структуры',
            groupId: 2,
            size: [1, 5],
            fieldNameText: 'acm_plan_name',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: '',
            groupId: 2,
            size: [1, 1],
            fieldNameText: 'acm_street_type',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Элемент улично-дорожной сети',
            groupId: 2,
            size: [1, 5],
            fieldNameText: 'acm_street_name',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Здание / сооружение',
            groupId: 2,
            size: [1, 2],
            fieldNameText: 'acm_house',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Помещение в пределах здания, сооружения',
            groupId: 2,
            size: [1, 2],
            fieldNameText: 'acm_flat',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Помещение в пределах квартиры',
            groupId: 2,
            size: [1, 2],
            fieldNameText: 'acm_room',
        },

    ]
};
